var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"chatter-sidebar"}},[_vm._m(0),_c('sidebar-menu',{attrs:{"menu":_vm.menu,"theme":"black-theme","width":"auto","showOneChild":true,"hide-toggle":true},on:{"item-click":_vm.onMenuClick}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"topbar-logo",attrs:{"src":require("../../assets/logo_ey.png"),"alt":"EY Logo"}})])
}]

export { render, staticRenderFns }